var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import classNames from "classnames";
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCloseClick = function () {
            _this.setState({ show: false });
            setTimeout(function () { return _this.props.onClose && _this.props.onClose(); }, 150);
        };
        _this.state = {};
        return _this;
    }
    Modal.prototype.render = function () {
        var props = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classNames("modal fade", { show: this.state.show }), tabIndex: -1, role: "dialog" },
                React.createElement("div", { className: classNames("modal-dialog", { "modal-lg": !props.small && !props.xl, "modal-xl": props.xl }), role: "document" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: classNames("modal-header") },
                            React.createElement("div", { className: "modal-title" }, props.header),
                            this.props.onClose ? (React.createElement("button", { type: "button", className: "close", "aria-label": "Close", onClick: this.handleCloseClick },
                                React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))) : null),
                        props.children(this.handleCloseClick)))),
            React.createElement("div", { className: classNames("modal-backdrop fade", { show: this.state.show }) })));
    };
    Modal.prototype.componentDidMount = function () {
        var _this = this;
        // To make sure the modal has been "shown" before we "fade it in" we need a timeout
        setTimeout(function () { return _this.setState({ show: true }); }, 10);
    };
    return Modal;
}(React.PureComponent));
export { Modal };
//# sourceMappingURL=Modal.js.map